import React, { useEffect, useState } from 'react';
import { useApolloClient } from 'react-apollo';
import propTypes from 'prop-types';
import { FaSpinner } from 'react-icons/fa';
import './index.scss';
import logoKiper from '../../assets/images/logo-kiper.svg';
import logoPorter from '../../assets/images/logo-porter.svg';
import runtimeConfig from '../../utils/runtime';
import illustration from '../../assets/images/home-illustration.svg';
import AuthForm from '../../components/AuthForm';
import firebase, { isLoggedIn, linkAccount } from '../../services/firebase';
import useToast from '../../hooks/useToast';
import useQueryString from '../../hooks/useQueryString';
import Loader from '../../components/LogoLoader';
import authorizationGql from '../../utils/authorization.gql';

const logoImage = !runtimeConfig.RAZZLE_PROJECT || runtimeConfig.RAZZLE_PROJECT === 'kiper' ? logoKiper : logoPorter;

export default function Home({ history, match }) {
  const [isLoading, setLoading] = useState(false);
  const [isCheckingState, setCheckingState] = useState(true);
  const toast = useToast();
  const querystring = useQueryString();
  const apolloClient = useApolloClient();
  let skip = querystring.get('skip');
  const checkState = async () => {
    try {
      const redirectResult = await firebase.auth().getRedirectResult();
      if (redirectResult.user) {
        if (redirectResult.additionalUserInfo.isNewUser || !redirectResult.user.phoneNumber) {
          let url = '/register';
          if (match.params.slug) url += `/?slug=${match.params.slug}`;
          history.push(url);
          return;
        }

        let authorizationData;

        try {
          authorizationData = apolloClient.readQuery({
            query: authorizationGql,
          });
          await linkAccount(authorizationData);
          // eslint-disable-next-line
        } catch (e) {}
      }
      skip = false;
    } catch (e) {
      if (e.code.match(/account-exists/gi)) {
        toast.fire({
          icon: 'error',
          text:
            'Já existe uma conta vinculada ao email, efetue o login utilizado anteriormente para efetuarmos o vinculo das contas',
        });
        apolloClient.writeQuery({
          query: authorizationGql,
          data: {
            authorization: {
              credential: {
                ...e.credential,
                __typename: 'Credential',
              },
              email: e.email,
              __typename: 'Authorization',
            },
          },
        });
        setCheckingState(false);
        return;
      }
    }

    if (skip) {
      setCheckingState(false);
      return;
    }

    const isLogged = await isLoggedIn();
    if (isLogged) {
      let url = '/dashboard';
      if (match.params.slug) url = `/addcondominium/${match.params.slug}`;

      toast.fire({ icon: 'info', text: 'Bem vindo de volta!' });
      history.push(url);
    }
    setCheckingState(false);
  };

  useEffect(() => {
    checkState();
  }, [history, match, toast, apolloClient]);

  if (isCheckingState) return <Loader />;

  return (
    <div className="home d-flex justify-content-between flex-column">
      <div className="row header text-center">
        <div className="col">
          <img src={logoImage} alt="logo" className="logo" />
          <h5 className="mt-2 w-100">
            Bem-vindo a
            <br />
            <b>Assembleia Virtual</b>
          </h5>
          <img src={illustration} alt="ilustration" className="w-100 mt-1" />
        </div>
      </div>
      {isLoading && (
        <div className="row body p-5 mb-1">
          <div className="col text-center">
            <FaSpinner className="mb-3" />
            <p>O código de confirmação está sendo enviado</p>
          </div>
        </div>
      )}

      <>
        <div className="row body">
          {!isLoading && (
            <div className="col">
              <p>
                Defina pautas, crie
                <br />
                discussões e votações
              </p>
            </div>
          )}
        </div>
        <div className="footer">
          <AuthForm isLoading={isLoading} setLoading={setLoading} />
        </div>
      </>
    </div>
  );
}

Home.propTypes = {
  history: propTypes.object.isRequired,
  match: propTypes.object.isRequired,
};
